module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help"
  }, [_c('el-col', {
    staticClass: "login",
    attrs: {
      "xs": {
        offset: 1,
        span: 22
      },
      "md": {
        offset: 4,
        span: 16
      }
    }
  }, [_c('div', {
    staticClass: "panelheader"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.pageName))])]), _vm._v(" "), _c('div', {
    staticClass: "help-wrapper"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "h"
  }, [_vm._v("Check here for common problems")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://sporte.io/manual"
    }
  }, [_vm._v("User Manual")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "h"
  }, [_vm._v("Something not working correctly?")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://sporte.io/faults"
    }
  }, [_vm._v("Fault Reports")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "h"
  }, [_vm._v("Email us")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:hello@sporte.io"
    }
  }, [_vm._v("hello@sporte.io")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "h"
  }, [_vm._v("Support phone number")]), _vm._v(" "), _c('div', [_vm._v("1300 559 165")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c0517c3","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Help.vue
// module id = 968
// module chunks = 20